import classNames from 'classnames'

export default function SearchResult({ isInGrid, addTokenToGrid, children }) {
  return (
    <span className={classNames('inline-flex items-center rounded-md px-2 py-1 text-sm font-medium ring-1 ring-inset cursor-pointer', {
      'bg-gray-50 text-gray-600 ring-gray-500/10': !isInGrid,
      'bg-indigo-50 text-indigo-700 ring-indigo-700/10': isInGrid,
    })} onClick={addTokenToGrid}>
      {children}
    </span>
  )
}
